import { API_BASE } from './survey.config';

/**
 * The two public survey endpoints (my-dq-api services/survey/survey.svy.service.js).
 * Plain fetch on purpose: the module stays free of the host app's transport, auth
 * headers and 401 handling, so it can move anywhere.
 *
 * Resolves the `data` of the response; rejects with an Error carrying the API message.
 */

const request = async (path, options = {}) => {
    let res;
    try {
        res = await fetch(`${API_BASE}${path}`, {
            ...options,
            headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
        });
    } catch (e) {
        throw new Error('Could not reach the server. Please check your connection and try again.');
    }
    let body = null;
    try { body = await res.json(); } catch (e) { /* not JSON */ }
    if (!res.ok) {
        const err = new Error((body && body.message) || 'Something went wrong. Please try again.');
        err.status = res.status;
        err.code = body && body.code;
        throw err;
    }
    return body && body.data;
};

// GET — the latest published version: { survey_code, version, audience, title, intro, end, questions }.
// With a preview token from the admin portal: the unpublished draft, marked preview: true.
export const fetchSurvey = (survey_code, preview_token) =>
    request(`/survey/public/definition?survey_code=${encodeURIComponent(survey_code)}${
        preview_token ? `&preview_token=${encodeURIComponent(preview_token)}` : ''}`);

// POST — one response; safe to retry with the same client_submission_id.
// { survey_code, survey_version, client_submission_id, answers, started_at, locale }
export const submitSurveyResponse = (payload) =>
    request('/survey/public/responses', { method: 'POST', body: JSON.stringify(payload) });
